var _mask, _path, _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHistoryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_189_19059",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5078 16.2441C22.7226 16.6505 22.8867 17.0712 22.9984 17.5001H22.9999C22.8881 17.929 22.7241 18.3496 22.5093 18.756C22.0683 19.5901 21.4219 20.348 20.6071 20.9864C19.7923 21.6248 18.825 22.1312 17.7604 22.4767C16.6958 22.8222 15.5548 23 14.4025 23C13.2502 23 12.1092 22.8222 11.0446 22.4767C9.97997 22.1312 9.01266 21.6248 8.19785 20.9864C7.38304 20.348 6.7367 19.5901 6.29574 18.756C6.0809 18.3496 5.91685 17.929 5.80511 17.5001H5.80359C5.91534 17.0712 6.07939 16.6505 6.29424 16.2441C6.73521 15.41 7.38155 14.6521 8.19635 14.0137C9.01116 13.3753 9.97847 12.8688 11.0431 12.5233C12.1077 12.1778 13.2487 12 14.401 12C15.5533 12 16.6943 12.1778 17.7589 12.5233C18.8235 12.8688 19.7908 13.3753 20.6056 14.0137C21.4204 14.6521 22.0668 15.41 22.5078 16.2441Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9984 17.5001L22.0307 17.7522L22.2255 18.5001H22.9984V17.5001ZM22.5078 16.2441L23.3918 15.7768L22.5078 16.2441ZM22.9999 17.5001L23.9676 17.7522L24.2938 16.5001H22.9999V17.5001ZM22.5093 18.756L21.6252 18.2886L22.5093 18.756ZM20.6071 20.9864L19.9904 20.1992L19.9904 20.1992L20.6071 20.9864ZM17.7604 22.4767L17.4517 21.5255L17.4517 21.5255L17.7604 22.4767ZM11.0446 22.4767L11.3533 21.5255L11.0446 22.4767ZM8.19785 20.9864L8.81459 20.1992H8.81459L8.19785 20.9864ZM6.29574 18.756L5.41168 19.2234H5.41168L6.29574 18.756ZM5.80511 17.5001L6.7728 17.248L6.57795 16.5001H5.80511V17.5001ZM5.80359 17.5001L4.83589 17.248L4.50969 18.5001H5.80359V17.5001ZM6.29424 16.2441L5.41018 15.7768H5.41018L6.29424 16.2441ZM8.19635 14.0137L8.81311 14.8008V14.8008L8.19635 14.0137ZM11.0431 12.5233L10.7344 11.5722L11.0431 12.5233ZM17.7589 12.5233L18.0676 11.5722V11.5722L17.7589 12.5233ZM20.6056 14.0137L19.9889 14.8008L19.9889 14.8008L20.6056 14.0137ZM23.9661 17.248C23.8343 16.7421 23.6417 16.2494 23.3918 15.7768L21.6237 16.7115C21.8035 17.0517 21.939 17.4002 22.0307 17.7522L23.9661 17.248ZM22.9999 16.5001H22.9984V18.5001H22.9999V16.5001ZM23.3933 19.2234C23.6432 18.7507 23.8358 18.2581 23.9676 17.7522L22.0322 17.248C21.9405 17.6 21.805 17.9485 21.6252 18.2886L23.3933 19.2234ZM21.2239 21.7735C22.1384 21.057 22.8805 20.1933 23.3933 19.2234L21.6252 18.2886C21.256 18.9869 20.7055 19.639 19.9904 20.1992L21.2239 21.7735ZM18.0691 23.4278C19.2361 23.0491 20.3096 22.4899 21.2239 21.7735L19.9904 20.1992C19.2751 20.7596 18.4139 21.2133 17.4517 21.5255L18.0691 23.4278ZM14.4025 24C15.6565 24 16.9019 23.8066 18.0691 23.4278L17.4517 21.5255C16.4898 21.8377 15.4531 22 14.4025 22V24ZM10.7359 23.4278C11.9031 23.8066 13.1485 24 14.4025 24V22C13.3519 22 12.3152 21.8377 11.3533 21.5255L10.7359 23.4278ZM7.58111 21.7735C8.49543 22.4899 9.56887 23.0491 10.7359 23.4278L11.3533 21.5255C10.3911 21.2133 9.52989 20.7596 8.81459 20.1992L7.58111 21.7735ZM5.41168 19.2234C5.92444 20.1933 6.66656 21.057 7.58111 21.7735L8.81459 20.1992C8.09953 19.639 7.54897 18.9869 7.17979 18.2886L5.41168 19.2234ZM4.83741 17.7522C4.9692 18.2581 5.16181 18.7507 5.41168 19.2234L7.17979 18.2886C6.99998 17.9485 6.86451 17.6 6.7728 17.248L4.83741 17.7522ZM5.80359 18.5001H5.80511V16.5001H5.80359V18.5001ZM5.41018 15.7768C5.1603 16.2494 4.96768 16.7421 4.83589 17.248L6.77129 17.7522C6.86299 17.4002 6.99847 17.0517 7.1783 16.7115L5.41018 15.7768ZM7.5796 13.2265C6.66505 13.9431 5.92294 14.8068 5.41018 15.7768L7.1783 16.7115C7.54748 16.0132 8.09805 15.3611 8.81311 14.8008L7.5796 13.2265ZM10.7344 11.5722C9.56736 11.9509 8.49392 12.5101 7.5796 13.2265L8.81311 14.8008C9.5284 14.2404 10.3896 13.7868 11.3518 13.4745L10.7344 11.5722ZM14.401 11C13.147 11 11.9016 11.1934 10.7344 11.5722L11.3518 13.4745C12.3137 13.1623 13.3504 13 14.401 13V11ZM18.0676 11.5722C16.9004 11.1934 15.655 11 14.401 11V13C15.4516 13 16.4883 13.1623 17.4502 13.4745L18.0676 11.5722ZM21.2224 13.2265C20.3081 12.5101 19.2346 11.9509 18.0676 11.5722L17.4502 13.4745C18.4124 13.7868 19.2736 14.2404 19.9889 14.8008L21.2224 13.2265ZM23.3918 15.7768C22.8791 14.8068 22.1369 13.9431 21.2224 13.2265L19.9889 14.8008C20.704 15.3611 21.2545 16.0132 21.6237 16.7115L23.3918 15.7768Z",
    fill: "#95A1C6",
    mask: "url(#path-1-inside-1_189_19059)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4,
    cy: 17.5001,
    rx: 3.43895,
    ry: 3.49997,
    fill: "#95A1C6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1.20091,
    height: 22,
    fill: "#95A1C6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.20093,
    y: 1,
    width: 13.21,
    height: 1.22222,
    fill: "#95A1C6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.40186,
    y: 4.66675,
    width: 9.60731,
    height: 1.22222,
    fill: "#95A1C6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.411,
    y: 2.22229,
    width: 1.20091,
    height: 3.66667,
    fill: "#95A1C6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2101,
    y: 2.22229,
    width: 1.20091,
    height: 3.66667,
    fill: "#95A1C6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6119,
    y: 3.44446,
    width: 1.20091,
    height: 2.44444,
    fill: "#95A1C6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.40186,
    y: 8.33325,
    width: 9.60731,
    height: 1.22222,
    fill: "#95A1C6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.40186,
    y: 12,
    width: 3.60274,
    height: 1.22222,
    fill: "#95A1C6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2.20093,
    y: 21.7777,
    width: 4.80365,
    height: 1.22222,
    fill: "#95A1C6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8129,
    y: 4.66675,
    width: 1.20091,
    height: 7.33333,
    fill: "#95A1C6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistoryWhite);
export default __webpack_public_path__ + "static/media/icon_history_white.60041f8e0f508cf5ae24d9acfdc1610e.svg";
export { ForwardRef as ReactComponent };